import { LookupAction } from '@rx/http'

export class ProjectNegotionalityLookups {
    static teamRoles: LookupAction = {
        controllerName: "projectnegotionality",
        actionName: "teamRoles",
		cacheOption: {
            isVersionBase: true,
            tableName:''
        }
    };

    static userLookups: LookupAction = {
        controllerName: "projectnegotionality",
        actionName: "userLookups",
		cacheOption: {
            isVersionBase: true,
            tableName:''
        }
    };

    static negotiabilityuserlookups: LookupAction = {
        controllerName: "projectnegotionality",
        actionName: "negotiabilityuserlookups",
		cacheOption: {
            isVersionBase: true,
            tableName:''
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/lookups/project-negotionality-lookups.ts